import axios from 'axios';

const API_ENDPOINT =
  'https://prod-81.westeurope.logic.azure.com:443/workflows/bd5defaac8a248e5bfab221b0661b57d/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=n4TAMtRQevEq-TQoyboNq0bl5AoAWEgG_0IUbez9A8I';

export function submit({
  currentSituationImages = [],
  futureSituationImages = [],
  ...payload
}) {
  const formData = new FormData();

  formData.append(
    'information',
    new Blob([JSON.stringify(payload)], { type: 'application/json' })
  );

  currentSituationImages.forEach((file, index) => {
    formData.append(
      `currentSituationImages${[index]}`,
      file.originFileObj,
      file.name
    );
  });
  futureSituationImages.forEach((file, index) => {
    formData.append(
      `futureSituationImages${[index]}`,
      file.originFileObj,
      file.name
    );
  });

  return axios.post(API_ENDPOINT, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
